import { RootInitialState } from '../rootReducer';

export const getIsTestingEnv = (state: RootInitialState) => {
  return state.system.isTestingEnv;
};

export const getIsInAppBrowser = (state: RootInitialState) => {
  return state.system.isInAppBrowser;
};

export const getSystemPlatform = (state: RootInitialState) => {
  return state.system.platform;
};
